<div class="row title">
    <h3>Dashboard / <span class="addCursor" [routerLink]="['/designer/leads']" routerLinkActive="active" [queryParams]="{customer_status: customer_status}">Lead</span> /<span [routerLink]="['/projects/view/'+id]" routerLinkActive="active" [queryParams]="{customer_status: customer_status}" class="addCursor">Project </span>/ <span>Add Floorplan</span></h3>
</div>
<div class="row inputForm bg_dashboard justify-content-center">
  <div class="col-12" *ngIf="erroralert">
    <div class="alert-box grid-100" *ngIf="errorMessage">
      <div class="alert alert-danger mt-3 text-center">
        <a class="close link" data-dismiss="alert" (click)="erroralert=false">×</a>
        {{errorMessage}}
      </div>
    </div>
  </div>
  <div class="col-12" *ngIf="successalert">
    <div class="alert-box grid-100" *ngIf="successMessage">
      <div class="alert alert-success mt-3 text-center">
        <a class="close link" data-dismiss="alert"  (click)="successalert=false">×</a>
        {{successMessage}}
      </div>
    </div>
  </div>
  <div class="col-11">
    <div class="card">
      <div class="card-body card_main">
        <form (ngSubmit)="onSubmit(createFloorplanForm.value); createFloorplanForm.reset()" #createFloorplanForm="ngForm" class="form-horizontal" enctype="multipart/form-data">
        <div class="row justify-content-center">
            <div class="col-12 col-md-7">
              <input type="text" class="form-control" id="name" placeholder="Floorplan Name*" required name="name" #name="ngModel" ngModel>
              <textarea class="form-control" id="details" name="details" #details="ngModel" rows="5" ngModel placeholder="Floorplan Details" >
              </textarea>
            </div>
            <div class="col-6 col-md-3 pt-4">
                <label class="text-left">Upload File*</label>
                <input type="file" class="" (change)="onChange($event)" name="attachment_file" ngModel #attachment_file="ngModel">

            </div>
            <div class="col-md-12">
              <button type="submit" class="button button_emi pull-right" [disabled]="!createFloorplanForm.valid || basefile==undefined ">Submit</button>
            </div>
        </div>
        </form>
      </div>
    </div>
  </div>
</div>



// WEBPACK FOOTER //
// ./src/app/platform/floorplans/floorplan/createfloorplan/createfloorplan.component.html